import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as UserIcon } from '../icons/user-icon.svg';
import { ROUTES } from './constants';

const MobileAuth = ({ currentUser, onLogout, isLoggingOut, onLoginClick, onCloseMenu }) => {
  if (currentUser) {
    return (
      <div className="mobile-menu-auth">
        <div className="mobile-menu-user-info">
          <span>Welcome, {currentUser.displayName || currentUser.email}</span>
        </div>
        <Link
          to={ROUTES.PROFILE}
          className="mobile-menu-link"
          onClick={onCloseMenu}
        >
          <UserIcon style={{ marginRight: '8px' }} />
          <span>Profile</span>
        </Link>
        <button
          className="mobile-menu-link mobile-logout-btn"
          onClick={onLogout}
          disabled={isLoggingOut}
        >
          <span>{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
        </button>
      </div>
    );
  }

  return (
    <div className="mobile-menu-auth">
      <button
        className="mobile-menu-link mobile-login-btn"
        onClick={() => {
          onLoginClick();
          onCloseMenu();
        }}
      >
        <span>Sign in</span>
      </button>
    </div>
  );
};

export default MobileAuth;

